
/**
 * @component Avatar
 *
 * @public
 */

export default {
  name: 'AvatarComponent',
  props: {
    src: {
      type: String,
      default: null,
    },
    firstName: {
      type: String,
      required: true,
    },
    lastName: {
      type: String,
      required: true,
    },
    left: {
      type: Boolean,
    },
  },
  computed: {
    getColor() {
      const colors = ['#009fd4', '#888888', '#000011'];

      return colors[Math.round(Math.random() * 3)];
    },
  },
};
